import React, { useEffect, useState } from 'react';
import './App.css';
import { db } from './firebase';
import { collection, addDoc, serverTimestamp, doc, setDoc, deleteDoc, query, where, getDocs } from 'firebase/firestore';

// Importando as imagens
import artur1 from './IMG/artur.jpeg';
import artur2 from './IMG/artur2.jpeg';
import artur3 from './IMG/artur3.jpeg';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [sessionId, setSessionId] = useState(null);

  // Função para gerar ID de sessão único
  const generateSessionId = () => {
    return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  };

  // Registrar visita da página
  useEffect(() => {
    const registerPageVisit = async () => {
      try {
        // Gerar ou recuperar ID de sessão
        let currentSessionId = sessionStorage.getItem('sessionId');
        if (!currentSessionId) {
          currentSessionId = generateSessionId();
          sessionStorage.setItem('sessionId', currentSessionId);
        }
        setSessionId(currentSessionId);

        // Registrar visita
        await addDoc(collection(db, 'codexPageVisits'), {
          sessionId: currentSessionId,
          timestamp: serverTimestamp(),
          page: window.location.pathname,
          userAgent: navigator.userAgent
        });

        // Registrar usuário ativo
        await setDoc(doc(db, 'codexActiveUsers', currentSessionId), {
          sessionId: currentSessionId,
          lastActive: serverTimestamp(),
          userAgent: navigator.userAgent
        });

        // Configurar heartbeat para manter usuário ativo
        const heartbeatInterval = setInterval(async () => {
          await setDoc(doc(db, 'codexActiveUsers', currentSessionId), {
            sessionId: currentSessionId,
            lastActive: serverTimestamp(),
            userAgent: navigator.userAgent
          }, { merge: true });
        }, 15000); // A cada 15 segundos

        return () => {
          clearInterval(heartbeatInterval);
          // Remover usuário ativo ao sair
          deleteDoc(doc(db, 'codexActiveUsers', currentSessionId));
        };
      } catch (error) {
        console.error('Erro ao registrar visita:', error);
      }
    };

    registerPageVisit();
  }, []);

  // Registrar clique em botão
  const registerClick = async (buttonName, buttonLocation, additionalData = {}) => {
    try {
      await addDoc(collection(db, 'codexClickMetrics'), {
        button: buttonName,
        buttonLocation: buttonLocation,
        sessionId: sessionId || sessionStorage.getItem('sessionId'),
        timestamp: serverTimestamp(),
        page: window.location.pathname,
        ...additionalData
      });
    } catch (error) {
      console.error('Erro ao registrar clique:', error);
    }
  };

  // Limpar usuários inativos (opcional - pode ser chamado periodicamente)
  const cleanInactiveUsers = async () => {
    try {
      const thirtySecondsAgo = new Date(Date.now() - 30000);
      const q = query(
        collection(db, 'codexActiveUsers'),
        where('lastActive', '<=', thirtySecondsAgo)
      );
      const snapshot = await getDocs(q);
      snapshot.forEach(async (doc) => {
        await deleteDoc(doc.ref);
      });
    } catch (error) {
      console.error('Erro ao limpar usuários inativos:', error);
    }
  };

  useEffect(() => {
    // Limpar usuários inativos a cada minuto
    const cleanInterval = setInterval(cleanInactiveUsers, 60000);
    return () => clearInterval(cleanInterval);
  }, []);

  // Função para abrir WhatsApp com registro
  const openWhatsApp = (message = '', buttonName = 'WhatsApp Button', buttonLocation = '') => {
    const phone = '5538999267532';
    const text = message ? `?text=${encodeURIComponent(message)}` : '';
    
    // Registrar clique
    registerClick(buttonName, buttonLocation, {
      phone: phone,
      message: message || 'Mensagem padrão'
    });

    // Abrir WhatsApp
    window.open(`https://wa.me/${phone}${text}`, '_blank');
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
      registerClick('Navigation Menu', sectionId);
    }
  };

  return (
    <div className="App">
      {/* Navbar */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <div className="nav-logo">
            <span className="logo-text">artur</span>
            <span className="logo-highlight">barros</span>
          </div>
          <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <button onClick={() => scrollToSection('inicio')} className="nav-link">Início</button>
            <button onClick={() => scrollToSection('sobre')} className="nav-link">Sobre</button>
            <button onClick={() => scrollToSection('produtos')} className="nav-link">Produtos</button>
            <button onClick={() => scrollToSection('contato')} className="nav-link">Contato</button>
            <button 
              onClick={() => openWhatsApp('', 'Navbar WhatsApp Button', 'navbar')} 
              className="nav-link nav-link-wpp"
            >
              <span className="wpp-icon">📱</span> WhatsApp
            </button>
          </div>
          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="inicio" className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="glitch-text" data-text="Artur Barros">Artur Barros</h1>
            <p className="hero-subtitle">De 0 a 1 Milhão: A Jornada de um Jovem que Transformou a Internet em Oportunidade</p>
            <p className="hero-description">
              Aos 22 anos, construí um império digital baseado em tecnologia, anúncios e estratégias de vendas. 
              Agora, vou te ensinar o caminho das pedras.
            </p>
            <div className="hero-buttons">
              <button 
                onClick={() => openWhatsApp(
                  'Olá Artur! Tenho interesse na mentoria Do 0 ao 1 Milhão',
                  'Hero Mentoria Button',
                  'hero-section'
                )} 
                className="btn-primary"
              >
                <span className="btn-icon">🚀</span>
                Conheça minha mentoria
              </button>
              <button 
                onClick={() => {
                  scrollToSection('sobre');
                  registerClick('Saiba Mais Button', 'hero-section');
                }} 
                className="btn-secondary"
              >
                <span className="btn-icon">📖</span>
                Saiba mais
              </button>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src={artur1} 
              alt="Artur Barros" 
              className="hero-img"
              loading="eager"
            />
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-grid">
          <div className="stat-item">
            <h2 className="stat-number">1.5M+</h2>
            <p className="stat-label">Faturamento Anual</p>
          </div>
          <div className="stat-item">
            <h2 className="stat-number">22</h2>
            <p className="stat-label">Anos de Idade</p>
          </div>
          <div className="stat-item">
            <h2 className="stat-number">100%</h2>
            <p className="stat-label">Resultados Comprovados</p>
          </div>
          <div className="stat-item">
            <h2 className="stat-number">2</h2>
            <p className="stat-label">Mentorias Exclusivas</p>
          </div>
        </div>
      </section>

      {/* Sobre Section */}
      <section id="sobre" className="about-section">
        <div className="section-header">
          <h2 className="section-title">Quem é <span className="gradient-text">Artur Barros</span></h2>
          <div className="section-divider"></div>
        </div>
        <div className="about-content">
          <div className="about-images">
            <img 
              src={artur2} 
              alt="Artur Barros" 
              className="about-img about-img-1"
              loading="lazy"
            />
            <img 
              src={artur3} 
              alt="Artur Barros" 
              className="about-img about-img-2"
              loading="lazy"
            />
          </div>
          <div className="about-text">
            <p className="about-paragraph">
              Aos 22 anos, minha história é prova viva de que a internet pode transformar vidas. 
              Comecei do zero, com apenas um computador e muita vontade de aprender. Hoje, 
              faturo mais de 1 milhão por ano combinando três pilares essenciais: 
              <span className="highlight"> tecnologia, tráfego pago e vendas</span>.
            </p>
            <p className="about-paragraph">
              Minha jornada não foi fácil. Passei noites estudando, testando estratégias, 
              errando e aprendendo. Mas cada obstáculo superado me trouxe até aqui: um lugar 
              onde posso compartilhar todo esse conhecimento com quem realmente quer resultados.
            </p>
            <p className="about-paragraph">
             Sou um profissional que domina as stacks 
              de anúncios do Meta Ads e Google Ads, além de ter conhecimentos profundos e avançados em 
              tecnologia e programação que me permitem criar soluções únicas e escaláveis.
            </p>
            <div className="about-stats">
              <div className="about-stat">
                <span className="about-stat-number">3+</span>
                <span className="about-stat-label">Anos de Experiência</span>
              </div>
              <div className="about-stat">
                <span className="about-stat-number">100+</span>
                <span className="about-stat-label">Alunos Mentoreados</span>
              </div>
              <div className="about-stat">
                <span className="about-stat-number">100+</span>
                <span className="about-stat-label">Campanhas de Sucesso</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Produtos Section */}
      <section id="produtos" className="products-section">
        <div className="section-header">
          <h2 className="section-title">Minhas <span className="gradient-text">Mentorias</span></h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            Escolha o caminho que mais se adequa aos seus objetivos e comece sua jornada rumo ao 1 milhão
          </p>
        </div>

        <div className="products-grid">
          {/* Produto 1 */}
          <div className="product-card">
            <div className="product-badge">MAIS POPULAR</div>
            <div className="product-header">
              <h3 className="product-title">Do 0 ao 1 Milhão</h3>
              <p className="product-subtitle">Domine as Stacks de Anúncios</p>
            </div>
            <div className="product-price">
              <span className="price">R$ 1.000</span>
              <span className="price-detail">ou 12x de R$ 97</span>
            </div>
            <ul className="product-features">
              <li>✓ Reuniões estratégicas 1:1 para analisar seu momento atual e definir estratégias personalizadas para seu negócio ou projeto</li>
              <li>✓ Meta Ads do básico ao avançado</li>
              <li>✓ Google Ads completo</li>
              <li>✓ Estratégias de segmentação</li>
              <li>✓ Otimização de campanhas</li>
              <li>✓ Análise de métricas e ROI</li>
              <li>✓ Criação de funis de venda</li>
              <li>✓ Suporte direto e individual</li>
            </ul>
            <button 
              onClick={() => openWhatsApp(
                'Olá Artur! Quero começar na mentoria Do 0 ao 1 Milhão (R$ 1.000)',
                'Produto Básico Button',
                'products-section'
              )} 
              className="btn-product"
            >
              <span className="btn-icon">⚡</span>
              Quero começar agora
            </button>
          </div>

          {/* Produto 2 */}
          <div className="product-card product-card-pro">
            <div className="product-badge product-badge-pro">RECOMENDADO</div>
            <div className="product-header">
              <h3 className="product-title">Do 0 ao 1 Milhão PRO</h3>
              <p className="product-subtitle">Anúncios + Tecnologia e Programação</p>
            </div>
            <div className="product-price">
              <span className="price">R$ 2.000</span>
              <span className="price-detail">ou 12x de R$ 194</span>
            </div>
            <ul className="product-features">
              <li>✓ Tudo do plano anterior</li>
              <li>✓ Fundamentos de programação</li>
              <li>✓ Criação de sites e landing pages</li>
              <li>✓ Automações e integrações</li>
              <li>✓ Desenvolvimento de produtos digitais</li>
              <li>✓ Estratégias de escalabilidade</li>
              <li>✓ Suporte prioritário</li>
              <li>✓ Mentoria individual mensal</li>
            </ul>
            <button 
              onClick={() => openWhatsApp(
                'Olá Artur! Quero ser PRO na mentoria Do 0 ao 1 Milhão (R$ 2.000)',
                'Produto PRO Button',
                'products-section'
              )} 
              className="btn-product btn-product-pro"
            >
              <span className="btn-icon">🔥</span>
              Quero ser PRO
            </button>
          </div>
        </div>

        <div className="products-description">
          <p>
            Não importa se você está começando do absoluto zero ou se já tem alguma experiência 
            mas precisa de direcionamento. Minhas mentorias foram desenvolvidas para te levar 
            do ponto A ao ponto B com um plano de ação claro e resultados mensuráveis.
          </p>
          <p className="highlight-quote">
            "Não é só conhecimento teórico. É a minha experiência prática, meus erros e acertos, 
            e tudo que me fez chegar onde estou hoje."
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Pronto para transformar sua realidade?</h2>
          <p className="cta-text">
            Junte-se a centenas de alunos que já estão trilhando o caminho do sucesso 
            com as estratégias que funcionam de verdade.
          </p>
          <button 
            onClick={() => openWhatsApp(
              'Olá Artur! Quero garantir minha vaga na mentoria',
              'CTA Button',
              'cta-section'
            )} 
            className="btn-primary btn-large"
          >
            <span className="btn-icon">🎯</span>
            Quero garantir minha vaga
          </button>
        </div>
      </section>

      {/* Contato Section */}
      <section id="contato" className="contact-section">
        <div className="section-header">
          <h2 className="section-title">Fale <span className="gradient-text">Comigo</span></h2>
          <div className="section-divider"></div>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <p className="contact-text">
              Tem dúvidas sobre as mentorias? Quer saber mais sobre como posso te ajudar 
              a alcançar seus objetivos? Entre em contato através dos canais abaixo:
            </p>
            <div className="contact-details">
              <div 
                className="contact-item" 
                onClick={() => openWhatsApp(
                  '',
                  'Contact WhatsApp Button',
                  'contact-section'
                )}
              >
                <span className="contact-icon">📱</span>
                <span className="contact-value">(38)99926-7532</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <span className="contact-value">arturbarrosmentoria@gmail.com</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📱</span>
                <span className="contact-value">@artur_maciejewsky</span>
              </div>
            </div>
            <div className="social-links">
              <a 
                href="https://www.instagram.com/artur_maciejewsky?igsh=cWoyOXRyZmowejRy&utm_source=qr" 
                className="social-link"
                onClick={() => registerClick('Instagram Link', 'contact-section')}
              >
                Instagram
              </a>
           
              <a 
                href="https://www.youtube.com/@arturmaciejewsky" 
                className="social-link"
                onClick={() => registerClick('YouTube Link', 'contact-section')}
              >
                YouTube
              </a>
              <a 
                href="https://www.tiktok.com/@tur_maciejewsky?_r=1&_t=ZS-94dI615YOjk" 
                className="social-link"
                onClick={() => registerClick('TikTok Link', 'contact-section')}
              >
                TikTok
              </a>
            </div>
          </div>
          <div className="contact-form">
            <h3 className="form-title">Envie uma mensagem</h3>
            <form onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              const name = formData.get('name');
              const email = formData.get('email');
              const message = formData.get('message');
              
              // Registrar clique do formulário
              registerClick('Contact Form Submit', 'contact-section', {
                name: name,
                email: email,
                message_preview: message.substring(0, 50)
              });

              openWhatsApp(
                `Olá Artur! Me chamo ${name}. ${message} (Contato: ${email})`,
                'Contact Form WhatsApp',
                'contact-section'
              );
            }}>
              <input 
                type="text" 
                name="name"
                placeholder="Seu nome" 
                className="form-input" 
                required
              />
              <input 
                type="email" 
                name="email"
                placeholder="Seu e-mail" 
                className="form-input" 
                required
              />
              <textarea 
                name="message"
                placeholder="Sua mensagem" 
                rows="5" 
                className="form-textarea"
                required
              ></textarea>
              <button type="submit" className="btn-primary btn-form">
                <span className="btn-icon">📤</span>
                Enviar mensagem
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <span className="logo-text">artur</span>
            <span className="logo-highlight">barros</span>
          </div>
          <p className="footer-copyright">
            © 2026 Artur Barros. Todos os direitos reservados.
          </p>
          <div className="footer-links">
            <a 
              href="#" 
              className="footer-link"
              onClick={() => registerClick('Terms Link', 'footer')}
            >
              Termos de uso
            </a>
            <a 
              href="#" 
              className="footer-link"
              onClick={() => registerClick('Privacy Link', 'footer')}
            >
              Política de privacidade
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;